import React, { useEffect, useState } from "react";
import axios from "axios";
import { appConfig } from "../../appConfig";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Checkbox, CheckboxChangeEvent, TextBox, TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { Pager, PageChangeEvent } from "@progress/kendo-react-data-tools";
import { TabStrip, TabStripSelectEventArguments, TabStripTab } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
// import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { GetAssetResponse } from "../../api/optima_image/OptimaImageClient";
import { iPageHeader } from "../../interfaces/iPageHeader";
import { AuthenticationResult } from "@azure/msal-browser";
import { getMesToken } from "../../auth/getAccessToken";
import { getMediaLinkAsJson } from "../question/edit/functions/questionDtoFunctions";
import VideoSelector from "./VideoSelector";
import ImageSelector from "./ImageSelector";
import { iImageLink, iVideo } from "./interfaces";
import { MediaContainer } from "./types";

const defaultHeader = {
  currentPage: 0,
  pageSize: 20,
  totalCount: 0,
  totalPages: 0,
  hasNext: false,
  hasPrevious: false,
};
const imageSizes: number[] = [300, 600, 1200];
const fixedOccupiedHeight: number = 300;
const factorDialog: number = 0.95;

const ImageDialog = (props: any) => {
  //TODO: Media Service

  const showVideoSelector: boolean = props.showVideoSelector ?? false;
  const [dialogHeight, setDialogHeight] = useState(window.innerHeight * factorDialog);
  const [imageContainerHeight, setImageContainerHeight] = useState(dialogHeight - fixedOccupiedHeight);
  const [selected, setSelected] = React.useState<number>(0);
  const [video, setVideo] = React.useState<iVideo>({ name: "", linkTypeId: 2, source: "" });

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []); // Empty dependency array ensures that this effect runs only once on mount

  // Function to handle window resize
  const handleResize = () => {
    let newDialogHeight = window.innerHeight * factorDialog;
    let newImageContainerHeight = newDialogHeight - fixedOccupiedHeight;

    // console.log("handleResize", newDialogHeight, newTreeviewHeight);
    setDialogHeight(newDialogHeight);
    setImageContainerHeight(newImageContainerHeight);
  };

  const handleTabSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  };

  return (
    <Dialog title={"Välj media"} onClose={props.onClose} width="80vw" height={`${dialogHeight}px`}>
      <div
        style={{
          marginRight: 10,
          // maxHeight: "80vh",
        }}
      >
        <TabStrip selected={selected} onSelect={handleTabSelect}>
          <TabStripTab title="Bilder">
            <ImageTab
              dialogHeight={dialogHeight}
              imageContainerHeight={imageContainerHeight}
              onOkClick={props.onOkClick}
            />
          </TabStripTab>
          {showVideoSelector && (
            <TabStripTab title="Video">
              <div
                style={{
                  borderStyle: "dotted",
                  borderWidth: "1px",
                  borderRadius: 10,
                  borderColor: "grey",
                  overflow: "auto",
                  marginRight: 10,
                  minWidth: "50vw",
                  maxWidth: "90vw",
                  height: "75vh",
                }}
              >
                <VideoSelector setVideo={setVideo} video={video} onOkClick={props.onOkClick} />
              </div>
            </TabStripTab>
          )}
        </TabStrip>
      </div>
    </Dialog>
  );
};

export default ImageDialog;

const ImageTab = (props: {
  dialogHeight: number;
  imageContainerHeight: number;
  onOkClick: (mediaContainer: MediaContainer) => void;
}) => {
  const { dialogHeight, imageContainerHeight } = props;
  const [pageHeader, setPageHeader] = React.useState<iPageHeader>(defaultHeader);
  const [images, setImages] = React.useState<GetAssetResponse[]>([]);
  const selectedImageSize: number = imageSizes[0];

  const onPageChange = (event: PageChangeEvent) => {
    let newPage: iPageHeader = { ...pageHeader };

    newPage.pageSize = event.take;
    newPage.currentPage = (event.skip + event.take) / event.take - 1;
    // console.log("event", newPage, event);
    setPageHeader(newPage);

    // fetchImages(newPage);
  };

  const onImageClick = (image: GetAssetResponse) => {
    // console.log(image);

    let mediaLink: iImageLink = getMediaLinkAsJson(image);
    const newMediaContainer: MediaContainer = { imageLinks: [mediaLink], videos: undefined } as MediaContainer;
    props.onOkClick(newMediaContainer);
  };

  console.log("pageHeader", pageHeader);

  return (
    <>
      <div className="row mb-2">
        <Search pageHeader={pageHeader} setPageHeader={setPageHeader} setImages={setImages} />
      </div>

      {images.length > 0 && (
        <div
          style={{
            borderStyle: "dotted",
            borderWidth: "1px",
            borderRadius: 10,
            borderColor: "grey",
            overflow: "auto",
            marginRight: 10,
            // minWidth: "50vw",
            // maxWidth: "70vw",
            height: imageContainerHeight,
          }}
          className=" mb-2"
        >
          <ImageSelector
            selectedImageSize={selectedImageSize}
            images={images}
            onImageClick={onImageClick}
            // pageHeader={pageHeader}
            // onPageChange={onPageChange}
            cols={dialogHeight < 800 ? 4 : 6}
            {...props}
          />
        </div>
      )}

      <Pager
        buttonCount={4}
        previousNext={true}
        skip={pageHeader.currentPage * pageHeader.pageSize}
        take={pageHeader.pageSize}
        total={pageHeader.totalCount}
        pageSizes={[10, 20, 30]}
        onPageChange={onPageChange}
      />
    </>
  );
};

const Search = (props: any) => {
  const { pageHeader, setPageHeader, setImages } = props;

  const [searchValue, setSearchValue] = React.useState<string>("");
  const [showDeprecated, setShowDeprecated] = useState<boolean>(false);

  // const [selectedImageSize, setSelectedImageSize] = useState<number>(imageSizes[0]);
  // const onImagSizeChange = (event: DropDownListChangeEvent) => {
  //   setSelectedImageSize(event.target.value as number);
  // };

  const fetchImages = async (currentPage: number, pageSize: number) => {
    let url = `${appConfig.REACT_APP_MEDIA_API_URL}/api/assets?search=${searchValue}`;
    url += `&page=${currentPage}&size=${pageSize}&container=images`;

    if (!showDeprecated) {
      url += `&excludeDeprecated=true`;
    }

    let token: AuthenticationResult = await getMesToken();

    // console.log(url);
    axios
      .get(url, { headers: { Authorization: `Bearer ${token.accessToken}` } })
      .then((response) => {
        // Access response headers
        const pageHeader: iPageHeader = JSON.parse(response.headers["x-pagination"]);
        setPageHeader(pageHeader);

        setImages(response.data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const searchImages = async (currentPage?: number, pageSize?: number) => {
    if (!searchValue || searchValue.length === 0) return;

    await fetchImages(currentPage || defaultHeader.currentPage, pageSize || defaultHeader.pageSize);
  };

  const onSearchChange = (e: TextBoxChangeEvent) => {
    const newValue = e.value as string;
    setSearchValue(newValue!);
  };
  const onSearchKeyDown = (e: any) => {
    if (e.key === "Enter") {
      searchImages();
    }
  };

  const onDeprecatedChange = (e: CheckboxChangeEvent) => {
    const newValue = e.value as boolean;
    setShowDeprecated(newValue);
  };

  // Search onPageChange
  useEffect(() => {
    searchImages(pageHeader.currentPage, pageHeader.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageHeader.currentPage, pageHeader.pageSize]);

  return (
    <div className="col-12">
      <div style={{ display: "inline-block" }}>
        <div>Sök:</div>
        <TextBox
          onKeyDown={(e: any) => onSearchKeyDown(e)}
          onChange={(e: TextBoxChangeEvent) => onSearchChange(e)}
          value={searchValue}
          style={{ width: "300px" }}
          className="k-textbox"
          rounded={"medium"}
        />
      </div>

      <div style={{ display: "inline-block" }} className="ms-3">
        <Checkbox
          onChange={(e: CheckboxChangeEvent) => onDeprecatedChange(e)}
          value={showDeprecated}
          label={"Visa utfasade bilder"}
        />
      </div>

      <div style={{ display: "inline-block" }} className="ms-3">
        <Button
          onClick={() => searchImages()}
          icon="search"
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary"
        />
      </div>

      {/* <div style={{ display: "none" }} className="ms-3">
            <div>Storlek:</div>
            <DropDownList
              data={imageSizes}
              onChange={onImagSizeChange}
              style={{ width: "150px" }}
              value={selectedImageSize}
            />
          </div> */}
    </div>
  );
};
